import type { QueryClient } from '@tanstack/react-query';
import { ReactFlowProvider } from '@xyflow/react';
import { useMemo, type ReactNode } from 'react';
import ERDFlowStore from '../../store/ERDFlowStore';
import { ERDFlowContext } from './ERDFlowContext';

interface ERDFlowProviderProps {
	rootId: string;
	queryClient: QueryClient;
	children: ReactNode;
}

function ERDFlowProvider({
	rootId,
	queryClient,
	children,
}: ERDFlowProviderProps) {
	const erdFlowStore = useMemo(
		() => new ERDFlowStore(rootId, queryClient),
		[rootId, queryClient]
	);

	return (
		<ERDFlowContext.Provider value={erdFlowStore}>
			<ReactFlowProvider>{children}</ReactFlowProvider>
		</ERDFlowContext.Provider>
	);
}

export default ERDFlowProvider;
